import React from 'react';
import classNames from 'classnames';
import CheckboxFieldGroup from 'components/CheckboxFieldGroup';
import { Field, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import InputField from 'components/InputField';
import validations from 'validations';

import './MemberOf.styles.scss';
import './MemberOf.styles.responsive.scss';

type MemberOfProps = {
  className?: string;
};

const accountantMemberOfOptions = [
  {
    label: 'CA',
    value: 'CA',
  },
  {
    label: 'CPA',
    value: 'CPA',
  },
  {
    label: 'IPAA',
    value: 'IPAA',
  },
];

const MemberOf: React.FC<MemberOfProps> = (props) => {
  const { className } = props;
  const { t } = useTranslation();
  const classes = classNames('member-of', className);

  const {
    values: { accountantMemberOf },
  } = useFormState();

  return (
    <div className={classes}>
      <CheckboxFieldGroup
        options={accountantMemberOfOptions}
        required
        name="accountantMemberOf"
      />
      <div>
        {accountantMemberOf?.CA && (
          <Field
            name="caMembershipNumber"
            component={InputField}
            validate={validations.required()}
            label={t('typeMembershipNumber', { type: 'CA' })}
          />
        )}
        {accountantMemberOf?.CPA && (
          <Field
            name="cpaMembershipNumber"
            component={InputField}
            validate={validations.required()}
            label={t('typeMembershipNumber', { type: 'CPA' })}
          />
        )}
        {accountantMemberOf?.IPAA && (
          <Field
            name="ipaaMembershipNumber"
            component={InputField}
            validate={validations.required()}
            label={t('typeMembershipNumber', { type: 'IPAA' })}
          />
        )}
      </div>
    </div>
  );
};

export default MemberOf;
